<kf-tooltip>
  <i 
    class="hint-tooltip fa fa-info-circle" 
    onmouseenter={ onMouseEnter } onmouseleave={ onMouseLeave }
  >
    <span class="hint-tip"><slot /></span>
  </i>


  <script>

    export default {

      onMouseEnter(e) {
        this.props.show({
          key: this.props.key ?? 'default',
          innerHTML: e.target.innerHTML,
          x: e.pageX,
          y: e.pageY,
        });
      },

      onMouseLeave(e) {
        this.props.hide({
          key: this.props.key ?? 'default',
        });
      },
    }

  </script>
  <style>
    .hint-tooltip {
      position: relative;
    }

    .hint-tip {
      display: none;
    }
  </style>
</kf-tooltip>